import { useQuery } from '@tanstack/react-query';
import api from '../utils/api.utils';
import { University, PaginatedResponse, UniversityQuery } from '../types';

const buildQueryParams = (query: UniversityQuery): URLSearchParams => {
  const params = new URLSearchParams();
  
  const addParam = (key: string, value: any) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, String(value));
    }
  };

  addParam('sort_by', query.sort_by);
  addParam('order', query.order);
  addParam('min_acceptance_rate', query.min_acceptance_rate);
  addParam('max_acceptance_rate', query.max_acceptance_rate);
  addParam('min_undergrads', query.min_undergrads);
  addParam('max_undergrads', query.max_undergrads);
  addParam('min_net_price', query.min_net_price);
  addParam('max_net_price', query.max_net_price);
  addParam('sat_min', query.sat_min);
  addParam('sat_max', query.sat_max);
  addParam('act_min', query.act_min);
  addParam('act_max', query.act_max);
  addParam('search', query.search);
  addParam('page', query.page);
  addParam('page_size', query.page_size);
  addParam('mylist', query.mylist);
  
  if (query.environment?.length) {
    addParam('environment', query.environment.join(','));
  }
  
  if (query.application_tags?.length) {
    addParam('application_tags', query.application_tags.join(','));
  }

  return params;
};

const fetchUniversities = async (query: UniversityQuery): Promise<PaginatedResponse<University>> => {
  const params = buildQueryParams(query);
  const response = await api.get(`/api/v1/universities/?${params.toString()}`);
  return response.data;
};

export const useUniversitiesSearch = (query: UniversityQuery, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['universities-search', query],
    queryFn: () => fetchUniversities(query),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
  });
};

export { fetchUniversities };
